var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoTruck = function SvgIcoTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.09 19.05"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.17 15.62h1.91a1 1 0 0 0 1-1V11a3.44 3.44 0 0 0-3.43-3.43h-3.81A.82.82 0 0 1 13 6.8V1.27l-3-.08-.45 8.59a2.72 2.72 0 0 1-2 2.48L1 14a1.61 1.61 0 0 0 1.62 1.61h15.55Z",
    style: {
      opacity: 0.3
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 9.33h-1.73a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h1.73a.5.5 0 0 0 .5-.5.51.51 0 0 0-.5-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.84 17.8 2.4A2.78 2.78 0 0 0 15.12.32L2.39 0A2.49 2.49 0 0 0 .7.67 2.35 2.35 0 0 0 0 2.35V14a2.61 2.61 0 0 0 2.62 2.61H4a2.68 2.68 0 0 0 5.33 0h4.45a2.68 2.68 0 0 0 5.33 0h.94a2 2 0 0 0 2-2V11A4.43 4.43 0 0 0 19 6.84Zm-3.14-3.93 1 3.7H14V2.29h1.08a.78.78 0 0 1 .78.62ZM6.69 17.05a.69.69 0 0 1-.69-.69.7.7 0 1 1 .69.69Zm9.79 0a.69.69 0 0 1-.7-.69.7.7 0 1 1 1.39 0 .69.69 0 0 1-.69.69Zm3.6-2.43h-1.56a2.66 2.66 0 0 0-4.09 0H14v-4.36a1 1 0 0 0-2 0v4.36H8.74a2.66 2.66 0 0 0-4.09 0h-2A.61.61 0 0 1 2 14V2.35a.34.34 0 0 1 .1-.25.42.42 0 0 1 .25-.1l9.65.24V6.8a1.81 1.81 0 0 0 1.82 1.81h3.82A2.43 2.43 0 0 1 20.09 11Z"
  })))));
};
export default SvgIcoTruck;